import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, MessageSquare, FileText, TrendingUp, Coins, Activity } from 'lucide-react';
import { formatNumber } from '@/utils/statisticsFormatters';

interface StatsOverviewCardsProps {
  data: {
    totals: {
      users: number;
      conversations: number;
      documents: number;
      casos: number;
      totalTokens: number;
    };
    plans: Array<{ plan: string; count: number }>;
    online: Array<{ date: string; count: number }>;
  };
}

export const StatsOverviewCards = ({ data }: StatsOverviewCardsProps) => {
  const maxOnline = Math.max(...data.online.map(o => o.count), 0);
  const totalPlansAdoptions = data.plans.reduce((acc, p) => acc + p.count, 0);

  const cards = [
    {
      title: 'Novos Usuários',
      value: data.totals.users,
      icon: Users,
      color: 'text-blue-500',
    },
    {
      title: 'Conversas Criadas',
      value: data.totals.conversations,
      icon: MessageSquare,
      color: 'text-green-500',
    },
    {
      title: 'Documentos Criados',
      value: data.totals.documents,
      icon: FileText,
      color: 'text-purple-500',
    },
    {
      title: 'Casos Criados',
      value: data.totals.casos,
      icon: FileText,
      color: 'text-orange-500',
    },
    {
      title: 'Consumo de Tokens',
      value: formatNumber(data.totals.totalTokens),
      icon: Coins,
      color: 'text-amber-500',
    },
    {
      title: 'Pico de Online',
      value: maxOnline,
      icon: Activity,
      color: 'text-green-500',
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{card.title}</CardTitle>
            <card.icon className={`h-4 w-4 ${card.color}`} />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{card.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
